import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

import alexus from "../images/Alexus.jpg"
import bannet from "../images/Bannet.jpg";
import barndonpearl from "../images/Barndol.jpg";
import Lucasmarble from "../images/Lucas Marble.jpg";


import milangrey from "../images/Milan Grey.jpg"
import elorawhite from "../images/Elora White.jpg";
import brellastone from "../images/Brella Stone Marbel.jpg";
import Ordinagris from "../images/Ordina Gris.jpg"

import Emmunabiancamarble from "../images/Emmuna Bianca Marble.jpg";
import Helengrey from "../images/Helen Grey.jpg";
import Julittepearl from "../images/Juliette Pearl.jpg";
import Renatagrey from "../images/Renata Gray.jpg";

import romangreymarbel from "../images/Roman Grey Marbel.jpg";
import satrinonica from "../images/Satren Onice.jpg";
import scottwhite from "../images/Scott White.jpg";
import silvergrain from "../images/Silver Grain Marble.jpg";

import thiagobeige from "../images/Thiago Beige.jpg";
import veronicacream from "../images/Veronica Cream.jpg";



function KajariaNouvella60X120() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />
            <div className='hardwarekarimpur'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Kajaria Nouvelle,
                                    600x1200mm<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                        <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                    </svg> </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

            <ScrollToTop smooth top="100" color="Darkblue" />
            <br />
            <div className="album py-0">
                <div className="container">

                    <h1 className='mb-0'><b><b style={{ color: "#001284ff" }}>Kajaria</b> Nouvelle</b></h1>
                    <p className='mb-0'><small> 600x1200mm, Unveiling the futuristic collection </small></p>
                </div>
            </div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={alexus} className="card-img-top" alt="alexus" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Alexus Bianca</h5>
                                            <p className="card-text">600x1200mm</p>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={bannet} className="card-img-top" alt="bannet" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Bennet Marble </h5>
                                            <p className="card-text">600x1200mm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={barndonpearl} className="card-img-top" alt="barndonpearl" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Barndon Pearl</h5>
                                            <p className="card-text">600x1200mm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Lucasmarble} className="card-img-top" alt="Lucasmarble" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Lucas Marble                    </h5>
                                            <p className="card-text">600x1200mm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={milangrey} className="card-img-top" alt="alexumilangrey" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Milan Grey</h5>
                                            <p className="card-text">600x1200mm</p>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={elorawhite} className="card-img-top" alt="elorawhite" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Elora White </h5>
                                            <p className="card-text">600x1200mm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={brellastone} className="card-img-top" alt="brellastone" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Brella Stone</h5>
                                            <p className="card-text">600x1200mm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Ordinagris} className="card-img-top" alt="Ordinagrish" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Ordina Gris                  </h5>
                                            <p className="card-text">600x1200mm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Emmunabiancamarble} className="card-img-top" alt="Emmunabiancamarble" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Emuna Bianca</h5>
                                            <p className="card-text">600x1200mm</p>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Helengrey} className="card-img-top" alt="Helengrey" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Helen Grey </h5>
                                            <p className="card-text">600x1200mm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Julittepearl} className="card-img-top" alt="Julittepearl" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Juliette Pearl</h5>
                                            <p className="card-text">600x1200mm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Renatagrey} className="card-img-top" alt="Renatagrey" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Renata Grey                 </h5>
                                            <p className="card-text">600x1200mm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>


            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={romangreymarbel} className="card-img-top" alt="romangreymarbel" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Roman Grey</h5>
                                            <p className="card-text">600x1200mm</p>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={satrinonica} className="card-img-top" alt="satrinonica" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Satren Onice </h5>
                                            <p className="card-text">600x1200mm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={scottwhite} className="card-img-top" alt="scottwhite" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Scott White</h5>
                                            <p className="card-text">600x1200mm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={silvergrain} className="card-img-top" alt="silvergrain" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Silver Grains              </h5>
                                            <p className="card-text">600x1200mm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>


            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={thiagobeige} className="card-img-top" alt="thiagobeige" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1"> Thiago Beige</h5>
                                            <p className="card-text">600x1200mm</p>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={veronicacream} className="card-img-top" alt="veronicacream" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Veronica Crema </h5>
                                            <p className="card-text">600x1200mm</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <div className="album py-2">
                <div className="container">
                    <h3>Update soon!</h3>
                </div>
            </div>


        </div>
    )
}

export default KajariaNouvella60X120